// See Tableau Web Data Connector API reference for details: https://tableau.github.io/webdataconnector/docs/api_ref.html
/**
 * Exhaustively checks if this object is a valid TableauAppendRowsArg. This is useful for scenarios
 * where you want to pass API data directly into Tableau without processing or modifying it. However,
 * this is a fairly expensive type checking operation, so it should be used somewhat sparingly and
 * ideally only on relatively small objects.
 * @param array
 */
// I can't figure out how to do this kind of type checking without an explicit any
// eslint-disable-next-line @typescript-eslint/no-explicit-any
var isTableauAppendRowsArg = function (array) {
    return array.length === 0 || (array.every(function (element) {
        return typeof element === 'object' &&
            Object.keys(element).every(function (key) {
                return element[key] === null ||
                    ['undefined', 'boolean', 'number', 'string'].includes(typeof element[key]);
            });
    }));
};
export { isTableauAppendRowsArg, };
